import React, { Component } from "react"
import PropTypes from "prop-types"
import TwCitySelector from "tw-city-selector/tw-city-selector"

class RegisterAddress extends Component {
  componentDidMount() {
    new TwCitySelector({
      el: ".address-selector",
      elCounty: ".county", // 在 el 裡查找 dom
      elDistrict: ".district",
    })
  }

  onCountyChange = (event) => {
    this.props.handleObjectChange({
      address_county: event.target.value,
    })
  }

  onDistrictChange = (event) => {
    this.props.handleObjectChange({
      address_district: event.target.value,
    })
  }

  render() {
    const { name } = this.props

    return (
      <div className="field is-horizontal address">
        <div className="field-label is-medium">
          <label className="label">購買人地址</label>
        </div>
        <div className="field-body">
          <div className="field is-grouped is-grouped-multiline address-selector">
            <div className="control">
              <div className="select">
                <select className="county" onChange={this.onCountyChange} />
              </div>
            </div>
            <div className="control">
              <div className="select">
                <select className="district" onChange={this.onDistrictChange} />
              </div>
            </div>
            <div className="control is-expanded">
              <input
                className="input"
                type="text"
                placeholder="地址"
                value={name}
                onChange={(e) =>
                  this.props.handleObjectChange({ address: e.target.value })
                }
              />
            </div>
          </div>
        </div>
      </div>
    )
  }
}

RegisterAddress.propTypes = {
  handleObjectChange: PropTypes.func.isRequired,
}

export default RegisterAddress



// WEBPACK FOOTER //
// ./src/components/RegisterAddress.js